'use strict';

angular
  .module('ClinicApp')
  .directive('resyncAlertBanner', function(OCClinicUtil) {
    return {
      templateUrl: '/views/directives/_resync-alert-banner.html',
      link: function($scope) {
        $scope.showIbHealthResyncModalAndTrackCta = function() {
          OCClinicUtil.showIbHealthResyncModal($scope.$parent.clinic);

          OpencareAnalytics.trackClick({
            pageType: OpencareAnalytics.pageTypes.APPOINTMENT_MANAGER,
            pageName: 'Appointment Manager',
            name: 'ib-resync-troubleshoot',
            section: 'banner',
            content: {
              value: 'open-resync-modal',
            },
            practiceId: _.get($scope, '$parent.clinic.id'),
          });

        };
      },
    };
  });
